/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint-disable quote-props */
/* eslint-disable key-spacing */

interface Route {
	[routeKey: string]: {
		/*
			url of the route
		*/
		href: string;

		/*
			should redirect to home page if user is not logged in
			value is considered as false if omitted
		*/
		private?: boolean,

        layout?: 'default',

		header?: {
			visible?: boolean,
		};

		mobileMenuBar?: {
			visible?: boolean,
		};

		footer?: {
			visible?: boolean,
		},
		appPrompt?: {
			visible?: boolean,
		},
		seo?: {
			dynamic?: boolean,
		},
		chooseLanguage?: {
			visible: boolean,
		}
		checkAuthorization?: boolean,
		redirectToHome?: boolean,
	};
}

export const setting = {
	private: false,
	layout: 'default',
	header: {
		visible: true,
	},
	mobileMenuBar: {
		visible: true,
	},
	footer: {
		visible: true,
	},
	appPrompt: {
		visible: true,
	},
	seo: {
		dynamic: false,
	},
	chooseLanguage : {
		visible: true,
	},
	checkAuthorization: true,
	redirectToHome: true,
};


export const route: Route = {
	'doctor-profile': 							{ 	href: '/dr/[name]', 												seo: { dynamic: true } 					},
	'center-profile': 							{ 	href: '/center/[name]', 											seo: { dynamic: true } 					},
	'get-appointment': 							{ 	href: '/get-appointment', 											seo: { dynamic: true }, 																	chooseLanguage: { visible: false }			},
	'search-doctors': 							{ 	href: '/explore/doctors', 											seo: { dynamic: true } 					},	
	'search-by-education-level-specialty-city': { 	href: '/explore/doctors/[educationLevel]/[specialty]/city/[city]', 	seo: { dynamic: true } 					},	
	'search-by-specialty': 						{ 	href: '/explore/doctors/[educationLevel]/[specialty]', 				seo: { dynamic: true } 					},	
	'search-by-education-level': 				{ 	href: '/explore/doctors/[educationLevel]', 							seo: { dynamic: true } 					},	
	'search-by-city': 							{ 	href: '/explore/doctors/city/[city]', 								seo: { dynamic: true } 					},	
	'payment': 									{ 	href: '/payment/invoice', 																	appPrompt: { visible: false }, 			private: true, 		chooseLanguage: { visible: false }					},
	'payment-finish': 							{ 	href: '/payment/finish', 																											private: true,		chooseLanguage: { visible: false }					},

	//user pages
	'profile': 									{ 	href: '/profile', 																													private: true							},
	'user-appointments': 						{ 	href: '/profile/appointments', 																										private: true,		 		redirectToHome: false, 				chooseLanguage: { visible: false }					},
	'video-call': 								{ 	href: '/video-call', 																		appPrompt: { visible: false },			private: true,												footer: { visible: false }, 		mobileMenuBar: { visible: false }				},

	//static pages
	'not-found': 								{ 	href: '/404', 																						},
	'privacy-policy': 							{ 	href: '/privacy-policy', 									seo: { dynamic: true } 					},
	'landing':									{ 	href: '/landing', 											seo: { dynamic: true }, 		appPrompt: { visible: false },  												},
	'contact': 									{ 	href: '/contact', 											seo: { dynamic: true } 					},
	'home': 									{ 	href: '/', 													seo: { dynamic: true } 					},
	'register': 								{ 	href: '/register', 											seo: { dynamic: true } 					},
	'about': 									{ 	href: '/about', 											seo: { dynamic: true } 					},
	'delete-account': 							{ 	href: '/deleteacc-request', 								seo: { dynamic: true } 					},

	//oneway HW onboarding pages
	'onboarding-admission': 					{ 	href: '/onboarding/admission', 								chooseLanguage: { visible: false },			checkAuthorization: false,		appPrompt: { visible: false },		footer: { visible: false }, 	header: { visible: false },		mobileMenuBar: { visible: false }							},
	'onboarding-intro': 						{ 	href: '/onboarding/intro', 									chooseLanguage: { visible: false },			checkAuthorization: false,		appPrompt: { visible: false },		footer: { visible: false }, 	header: { visible: false },		mobileMenuBar: { visible: false }		},
	'onboarding-services': 						{ 	href: '/onboarding/services', 								chooseLanguage: { visible: false },			checkAuthorization: false,		appPrompt: { visible: false },		footer: { visible: false }, 	header: { visible: false },		mobileMenuBar: { visible: false }				},
	'onboarding-service-schedule': 				{ 	href: '/onboarding/services/schedule', 						chooseLanguage: { visible: false },			checkAuthorization: false,		appPrompt: { visible: false },		footer: { visible: false }, 	header: { visible: false },		mobileMenuBar: { visible: false }			},
	'onboarding-finish': 						{ 	href: '/onboarding/finish', 								chooseLanguage: { visible: false },			checkAuthorization: false,		appPrompt: { visible: false },		footer: { visible: false }, 	header: { visible: false },		mobileMenuBar: { visible: false }			},
}

